<template>
  <div class="backgroundChart">
    <apexchart :height="height" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'


export default {
    components: { apexchart: VueApexCharts},
    props: ['height','serieName', 'title', 'dataArray','categories','typeChart'],
   
    data() {
      return {
        series: [{
              name: this.serieName,
              data: this.dataArray
        }],

        chartOptions:{
            chart: {
                    type: this.typeChart,
                    toolbar: {
                        show: true
                    },
                    zoom: {
                        enabled: true
                    }
            },
            title: {
              text: this.title,
              align: 'center',
              style: {
                fontSize: '16px'
              }
            },
            plotOptions: {
              bar: {
                dataLabels: {
                  position: 'top', // top, center, bottom
                },
              }
            },

            fill: {colors: ['#1937a0']},
            dataLabels: {
                enabled: true,
                offsetY: -10,      
                style: {
                    colors: ['#777']
                },
                background: {
                    enabled: true,
                    foreColor: '#fff',
                    color:"#000",
                    opacity: 1,
                },          
            },
        
            markers: {
                size: 0,
                strokeColors: "#1937a0",
            },

            stroke: {
                show: true,
                curve: 'smooth',
                lineCap: 'butt',
                colors: "#1937a0",
                width: 2,
                dashArray: 0,      
            },

         
            xaxis: { categories : this.categories},

             grid: {
                  
                padding: {
                    top: 0,
                    right: 15,
                    bottom: 0,
                    left: 0
                },  
            }
            
        }
        
      }
    }
   
}
</script>

<style scoped lang="scss">
  .backgroundChart{
    background: #fff
  }

</style>